import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GgProductHighlightsAdapter } from './product-highlights.adapter';
import { Product } from '@spartacus/core';

@Injectable()
export class GgProductHighlightsConnector {
  constructor(protected adapter: GgProductHighlightsAdapter) {}

  getProduct(productCode: string, retailerActionCode: string): Observable<Product> {
    return this.adapter.getProduct(productCode, retailerActionCode);
  }
}
